export const template = `
<div [hidden]="!active" class="sdc-tab-content" role="tabpanel">
    <ng-content></ng-content>
</div>
`;
